import * as React from 'react'
import HTag from 'components/common/HTag'

const WhySection = ({ heading, text1, text2 }) => (
  <section className="padding bg-suede-dark text-white">
    <div className="ctnr richtext">
      <HTag className="technical-lg" {...heading} />

      <p className="h2 leading-[1.5] text-[#fffa]">{text1}</p>
      {!!text2 && <p className="h2 leading-[1.5]">{text2}</p>}
    </div>
  </section>
)

export default WhySection
